export const redirectLogin = () => {
 if (typeof window !== "undefined") window.location.pathname = "/login"
}
